/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkInProgressLine
 */
export interface WorkInProgressLine {
    /**
     * 
     * @type {number}
     * @memberof WorkInProgressLine
     */
    line: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgressLine
     */
    uniqueSequenceNum?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    operation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    partNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgressLine
     */
    quantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgressLine
     */
    extendedPrice?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkInProgressLine
     */
    laborIncluded?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgressLine
     */
    labor?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    laborType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    partType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgressLine
     */
    sectionHeader?: string | null;
}

/**
 * Check if a given object implements the WorkInProgressLine interface.
 */
export function instanceOfWorkInProgressLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "line" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function WorkInProgressLineFromJSON(json: any): WorkInProgressLine {
    return WorkInProgressLineFromJSONTyped(json, false);
}

export function WorkInProgressLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkInProgressLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'line': json['line'],
        'uniqueSequenceNum': !exists(json, 'uniqueSequenceNum') ? undefined : json['uniqueSequenceNum'],
        'operation': !exists(json, 'operation') ? undefined : json['operation'],
        'description': json['description'],
        'partNumber': !exists(json, 'partNumber') ? undefined : json['partNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'extendedPrice': !exists(json, 'extendedPrice') ? undefined : json['extendedPrice'],
        'laborIncluded': !exists(json, 'laborIncluded') ? undefined : json['laborIncluded'],
        'labor': !exists(json, 'labor') ? undefined : json['labor'],
        'laborType': !exists(json, 'laborType') ? undefined : json['laborType'],
        'partType': !exists(json, 'partType') ? undefined : json['partType'],
        'sectionHeader': !exists(json, 'sectionHeader') ? undefined : json['sectionHeader'],
    };
}

export function WorkInProgressLineToJSON(value?: WorkInProgressLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'line': value.line,
        'uniqueSequenceNum': value.uniqueSequenceNum,
        'operation': value.operation,
        'description': value.description,
        'partNumber': value.partNumber,
        'quantity': value.quantity,
        'extendedPrice': value.extendedPrice,
        'laborIncluded': value.laborIncluded,
        'labor': value.labor,
        'laborType': value.laborType,
        'partType': value.partType,
        'sectionHeader': value.sectionHeader,
    };
}

